import ScrollBooster from 'scrollbooster';

const Vue = window.Vue;

function isNull (object) {
  return object === null;
}
function isUndefined (object) {
  // eslint-disable-next-line
  return typeof object === typeof void 0;
}
function isNullOrUndefined (object) {
  return isNull(object) || isUndefined(object);
}
function isDefined (object) {
  return !isNullOrUndefined(object);
}

Vue.filter('getSalePercent', function (item) {
  let percent;

  if (isDefined(item.prices.specialOffer)) {
    percent = (1 - item.prices.specialOffer.unitPrice.value / item.prices.default.unitPrice.value) * -100;
  } else {
    percent = (1 - item.prices.default.unitPrice.value / item.prices.rrp.unitPrice.value) * -100;
  }

  if (percent < 0) {
    return percent.toFixed(0).replace('.', App.decimalSeparator) + '%';
  }

  return '';
});

Vue.filter('getGraduatedPrice', function (item) {
  let prices = item && item.prices.graduatedPrices;
  const minQuantity = item && item.variation.minimumOrderQuantity;

  if (prices) {
    prices = prices.filter(price => price.minimumOrderQuantity > minQuantity);
    prices = [...prices].sort((priceA, priceB) => {
      return priceA.minimumOrderQuantity - priceB.minimumOrderQuantity;
    });

    if (prices && prices[prices.length - 1]) {
      return prices[prices.length - 1].unitPrice.formatted;
    }
  }

  return false;
});

// eslint-disable-next-line
Vue.component('carousel-herrrmann', {

  components: {
    SlotComponent: {
      functional: true,
      render: (createElement, context) => context.data.attrs.vnode
    }
  },

  props: {
    itemsPerPage:
        {
          type: Number,
          default: 5
        },
    itemsPerPageXs:
        {
          type: Number,
          default: 1
        },
    itemsPerPageSm:
        {
          type: Number,
          default: 2
        },
    itemsPerPageMd:
        {
          type: Number,
          default: 3
        },
    itemsPerPageLg:
        {
          type: Number,
          default: 4
        },
    itemsPerPageXll: {
      type: Number,
      default: 4
    },
    disableCarousel:
        {
          type: Boolean,
          default: false
        }
  },

  computed:
    {
      columnWidths () {
        return [
          'col-xs-w-' + this.itemsPerPageXs,
          'col-sm-w-' + this.itemsPerPageSm,
          'col-md-w-' + this.itemsPerPageMd,
          'col-lg-w-' + this.itemsPerPageLg,
          'col-xl-w-' + this.itemsPerPage,
          'col-xll-w-' + this.itemsPerPageXll
        ];
      }
    },

  mounted () {
    this.$nextTick(() => {
      this.initializeCarousel();
    });
  },

  updated () {
    this.initializeCarousel();
  },

  methods:
    {
      initializeCarousel () {
        if (this.$slots.items) {
          const $owl = $(this.$refs.carouselContainer);

          // do not render, if no html element is inside of the carousels container
          if (!$owl.children().length) {
            return;
          }

          $owl.owlCarousel({
            onInitialized () {
              $owl.find('.owl-carousel.owl-loaded').each(function () {
                $(this).trigger('refresh.owl.carousel');
              });
            },
            autoHeight: true,
            dots: true,
            items: this.itemsPerPage,
            responsive: {
              0: { items: this.itemsPerPageXs },
              576: { items: this.itemsPerPageSm },
              768: { items: this.itemsPerPageMd },
              992: { items: this.itemsPerPageLg },
              1200: { items: this.itemsPerPage },
              1770: { items: this.itemsPerPageXll }
            },
            lazyLoad: false,
            loop: true,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            margin: 30,
            mouseDrag: true,
            nav: true,
            navClass: [
              'owl-single-item-nav left carousel-control list-control-special',
              'owl-single-item-nav right carousel-control list-control-special'
            ],
            navContainerClass: '',
            navText: [
              '<i class="owl-single-item-control fa fa-chevron-left" aria-hidden="true"></i>',
              '<i class="owl-single-item-control fa fa-chevron-right" aria-hidden="true"></i>'
            ],
            smartSpeed: 350
          });
        }
      }
    },

  template: `<div class="row">
        <div class="col-12 col-lg-12" v-if="!disableCarousel">
            <div class="list-item-carousel owl-carousel owl-theme owl-single-item" ref="carouselContainer">
                <slot-component v-for="(item, index) in $slots.items" :key="index" :vnode="item" />
            </div>
        </div>

        <div class="col-12" v-else>
            <div class="carousel-flex" :class="columnWidths">
                <div class="column" v-for="item in $slots.items">
                    <slot-component :vnode="item"/>
                </div>
            </div>
        </div>
    </div>
    `
});

// eslint-disable-next-line
Vue.component('shipping-privacy-hint-check', {

  props: {
    template:
    {
      type: String,
      default: '#vue-shipping-privacy-hint-check'
    }
  },

  computed:
  {
    currentShippingProfile () {
      return this.shippingProfileList.find(profile => profile.parcelServicePresetId === this.shippingProfileId);
    },

    currentPrivacyHints () {
      if (this.currentShippingProfile && this.currentShippingProfile.shippingPrivacyInformation) {
        return this.currentShippingProfile.shippingPrivacyInformation.filter(entry => !!entry.showDataPrivacyAgreementHint);
      }

      return [];
    },

    privacyHintContent () {
      const andTranslation = this.$translate('Ceres::Template.checkoutShippingPrivacyHintAnd');

      let parcelServiceInformation = '';

      for (const hint of this.currentPrivacyHints) {
        if (parcelServiceInformation !== '') {
          parcelServiceInformation += ` ${andTranslation} `;
        }

        parcelServiceInformation += `<strong>${hint.parcelServiceName}, ${hint.parcelServiceAddress}</strong>`;
      }

      return this.$translate('Ceres::Template.checkoutShippingPrivacyHint', { parcelServiceInformation });
    },

    shippingProfileList () {
      return this.$store.state.checkout.shipping.shippingProfileList;
    },

    shippingProfileId () {
      return this.$store.state.checkout.shipping.shippingProfileId;
    },
    shippingPrivacyHintAccepted () {
      return this.$store.state.checkout.shippingPrivacyHintAccepted;
    }
  },

  watch:
  {
    currentShippingProfile (value, oldValue) {
      if (this.shippingPrivacyHintAccepted && value.parcelServiceId !== oldValue.parcelServiceId) {
        this.setValue(false);

        $(this.$refs.formCheck).fadeTo(100, 0.1).fadeTo(400, 1.0);
      } else if (value && !value.shippingPrivacyInformation[0].showDataPrivacyAgreementHint) {
        this.setValue(false);
      }
    }
  },

  methods:
  {
    setValue (value) {
      this.$store.commit('setShippingPrivacyHintAccepted', value);
    }
  }
});

/* eslint-disable */

// dayjs, utx, timezone 1.10.6
!(function (t, e) { typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = e() : typeof define === 'function' && define.amd ? define(e) : (t = typeof globalThis !== 'undefined' ? globalThis : t || self).dayjs = e(); }(this, function () { 'use strict'; const t = 1e3; const e = 6e4; const n = 36e5; const r = 'millisecond'; const i = 'second'; const s = 'minute'; const u = 'hour'; const a = 'day'; const o = 'week'; const f = 'month'; const h = 'quarter'; const c = 'year'; const d = 'date'; const $ = 'Invalid Date'; const l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/; const y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g; const M = { name: 'en', weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_') }; const m = function (t, e, n) { const r = String(t); return !r || r.length >= e ? t : '' + Array(e + 1 - r.length).join(n) + t; }; const g = { s: m, z: function (t) { const e = -t.utcOffset(); const n = Math.abs(e); const r = Math.floor(n / 60); const i = n % 60; return (e <= 0 ? '+' : '-') + m(r, 2, '0') + ':' + m(i, 2, '0'); }, m: function t(e, n) { if (e.date() < n.date()) return -t(n, e); const r = 12 * (n.year() - e.year()) + (n.month() - e.month()); const i = e.clone().add(r, f); const s = n - i < 0; const u = e.clone().add(r + (s ? -1 : 1), f); return +(-(r + (n - i) / (s ? i - u : u - i)) || 0); }, a: function (t) { return t < 0 ? Math.ceil(t) || 0 : Math.floor(t); }, p: function (t) { return { M: f, y: c, w: o, d: a, D: d, h: u, m: s, s: i, ms: r, Q: h }[t] || String(t || '').toLowerCase().replace(/s$/, ''); }, u: function (t) { return void 0 === t; } }; let D = 'en'; const v = {}; v[D] = M; const p = function (t) { return t instanceof _; }; const S = function (t, e, n) { let r; if (!t) return D; if (typeof t === 'string') v[t] && (r = t), e && (v[t] = e, r = t); else { const i = t.name; v[i] = t, r = i; } return !n && r && (D = r), r || !n && D; }; const w = function (t, e) { if (p(t)) return t.clone(); const n = typeof e === 'object' ? e : {}; return n.date = t, n.args = arguments, new _(n); }; const O = g; O.l = S, O.i = p, O.w = function (t, e) { return w(t, { locale: e.$L, utc: e.$u, x: e.$x, $offset: e.$offset }); }; var _ = (function () { function M(t) { this.$L = S(t.locale, null, !0), this.parse(t); } const m = M.prototype; return m.parse = function (t) { this.$d = (function (t) { const e = t.date; const n = t.utc; if (e === null) return new Date(NaN); if (O.u(e)) return new Date(); if (e instanceof Date) return new Date(e); if (typeof e === 'string' && !/Z$/i.test(e)) { const r = e.match(l); if (r) { const i = r[2] - 1 || 0; const s = (r[7] || '0').substring(0, 3); return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s); } } return new Date(e); }(t)), this.$x = t.x || {}, this.init(); }, m.init = function () { const t = this.$d; this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds(); }, m.$utils = function () { return O; }, m.isValid = function () { return !(this.$d.toString() === $); }, m.isSame = function (t, e) { const n = w(t); return this.startOf(e) <= n && n <= this.endOf(e); }, m.isAfter = function (t, e) { return w(t) < this.startOf(e); }, m.isBefore = function (t, e) { return this.endOf(e) < w(t); }, m.$g = function (t, e, n) { return O.u(t) ? this[e] : this.set(n, t); }, m.unix = function () { return Math.floor(this.valueOf() / 1e3); }, m.valueOf = function () { return this.$d.getTime(); }, m.startOf = function (t, e) { const n = this; const r = !!O.u(e) || e; const h = O.p(t); const $ = function (t, e) { const i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n); return r ? i : i.endOf(a); }; const l = function (t, e) { return O.w(n.toDate()[t].apply(n.toDate('s'), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n); }; const y = this.$W; const M = this.$M; const m = this.$D; const g = 'set' + (this.$u ? 'UTC' : ''); switch (h) { case c: return r ? $(1, 0) : $(31, 11); case f: return r ? $(1, M) : $(0, M + 1); case o: var D = this.$locale().weekStart || 0; var v = (y < D ? y + 7 : y) - D; return $(r ? m - v : m + (6 - v), M); case a: case d: return l(g + 'Hours', 0); case u: return l(g + 'Minutes', 1); case s: return l(g + 'Seconds', 2); case i: return l(g + 'Milliseconds', 3); default: return this.clone(); } }, m.endOf = function (t) { return this.startOf(t, !1); }, m.$set = function (t, e) { let n; const o = O.p(t); const h = 'set' + (this.$u ? 'UTC' : ''); const $ = (n = {}, n[a] = h + 'Date', n[d] = h + 'Date', n[f] = h + 'Month', n[c] = h + 'FullYear', n[u] = h + 'Hours', n[s] = h + 'Minutes', n[i] = h + 'Seconds', n[r] = h + 'Milliseconds', n)[o]; const l = o === a ? this.$D + (e - this.$W) : e; if (o === f || o === c) { const y = this.clone().set(d, 1); y.$d[$](l), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d; } else $ && this.$d[$](l); return this.init(), this; }, m.set = function (t, e) { return this.clone().$set(t, e); }, m.get = function (t) { return this[O.p(t)](); }, m.add = function (r, h) { let d; const $ = this; r = Number(r); const l = O.p(h); const y = function (t) { const e = w($); return O.w(e.date(e.date() + Math.round(t * r)), $); }; if (l === f) return this.set(f, this.$M + r); if (l === c) return this.set(c, this.$y + r); if (l === a) return y(1); if (l === o) return y(7); const M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[l] || 1; const m = this.$d.getTime() + r * M; return O.w(m, this); }, m.subtract = function (t, e) { return this.add(-1 * t, e); }, m.format = function (t) { const e = this; const n = this.$locale(); if (!this.isValid()) return n.invalidDate || $; const r = t || 'YYYY-MM-DDTHH:mm:ssZ'; const i = O.z(this); const s = this.$H; const u = this.$m; const a = this.$M; const o = n.weekdays; const f = n.months; const h = function (t, n, i, s) { return t && (t[n] || t(e, r)) || i[n].substr(0, s); }; const c = function (t) { return O.s(s % 12 || 12, t, '0'); }; const d = n.meridiem || function (t, e, n) { const r = t < 12 ? 'AM' : 'PM'; return n ? r.toLowerCase() : r; }; const l = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: a + 1, MM: O.s(a + 1, 2, '0'), MMM: h(n.monthsShort, a, f, 3), MMMM: h(f, a), D: this.$D, DD: O.s(this.$D, 2, '0'), d: String(this.$W), dd: h(n.weekdaysMin, this.$W, o, 2), ddd: h(n.weekdaysShort, this.$W, o, 3), dddd: o[this.$W], H: String(s), HH: O.s(s, 2, '0'), h: c(1), hh: c(2), a: d(s, u, !0), A: d(s, u, !1), m: String(u), mm: O.s(u, 2, '0'), s: String(this.$s), ss: O.s(this.$s, 2, '0'), SSS: O.s(this.$ms, 3, '0'), Z: i }; return r.replace(y, function (t, e) { return e || l[t] || i.replace(':', ''); }); }, m.utcOffset = function () { return 15 * -Math.round(this.$d.getTimezoneOffset() / 15); }, m.diff = function (r, d, $) { let l; const y = O.p(d); const M = w(r); const m = (M.utcOffset() - this.utcOffset()) * e; const g = this - M; let D = O.m(this, M); return D = (l = {}, l[c] = D / 12, l[f] = D, l[h] = D / 3, l[o] = (g - m) / 6048e5, l[a] = (g - m) / 864e5, l[u] = g / n, l[s] = g / e, l[i] = g / t, l)[y] || g, $ ? D : O.a(D); }, m.daysInMonth = function () { return this.endOf(f).$D; }, m.$locale = function () { return v[this.$L]; }, m.locale = function (t, e) { if (!t) return this.$L; const n = this.clone(); const r = S(t, e, !0); return r && (n.$L = r), n; }, m.clone = function () { return O.w(this.$d, this); }, m.toDate = function () { return new Date(this.valueOf()); }, m.toJSON = function () { return this.isValid() ? this.toISOString() : null; }, m.toISOString = function () { return this.$d.toISOString(); }, m.toString = function () { return this.$d.toUTCString(); }, M; }()); const b = _.prototype; return w.prototype = b, [['$ms', r], ['$s', i], ['$m', s], ['$H', u], ['$W', a], ['$M', f], ['$y', c], ['$D', d]].forEach(function (t) { b[t[1]] = function (e) { return this.$g(e, t[0], t[1]); }; }), w.extend = function (t, e) { return t.$i || (t(e, _, w), t.$i = !0), w; }, w.locale = S, w.isDayjs = p, w.unix = function (t) { return w(1e3 * t); }, w.en = v[D], w.Ls = v, w.p = {}, w; }));
!(function (t, i) { typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = i() : typeof define === 'function' && define.amd ? define(i) : (t = typeof globalThis !== 'undefined' ? globalThis : t || self).dayjs_plugin_utc = i(); }(this, function () { 'use strict'; const h = 'minute'; const c = /[+-]\d\d(?::?\d\d)?/g; const l = /([+-]|\d\d)/g; return function (t, i, n) { const e = i.prototype; n.utc = function (t) { return new i({ date: t, utc: !0, args: arguments }); }, e.utc = function (t) { const i = n(this.toDate(), { locale: this.$L, utc: !0 }); return t ? i.add(this.utcOffset(), h) : i; }, e.local = function () { return n(this.toDate(), { locale: this.$L, utc: !1 }); }; const s = e.parse; e.parse = function (t) { t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), s.call(this, t); }; const f = e.init; e.init = function () { let t; this.$u ? (t = this.$d, this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds()) : f.call(this); }; const u = e.utcOffset; e.utcOffset = function (e, t) { var i = this.$utils().u; if (i(e)) return this.$u ? 0 : i(this.$offset) ? u.call(this) : this.$offset; if (typeof e === 'string' && (e = (function () { var t = (void 0 === e ? '' : e).match(c); if (!t) return null; var i = ('' + t[0]).match(l) || ['-', 0, 0]; var t = i[0]; var i = 60 * +i[1] + +i[2]; return i == 0 ? 0 : t === '+' ? i : -i; }())) === null) return this; const s = Math.abs(e) <= 16 ? 60 * e : e; var i = this; return t ? (i.$offset = s, i.$u = e === 0) : e !== 0 ? (t = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset(), (i = this.local().add(s + t, h)).$offset = s, i.$x.$localOffset = t) : i = this.utc(), i; }; const o = e.format; e.format = function (t) { t = t || (this.$u ? 'YYYY-MM-DDTHH:mm:ss[Z]' : ''); return o.call(this, t); }, e.valueOf = function () { const t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || (new Date()).getTimezoneOffset()); return this.$d.valueOf() - 6e4 * t; }, e.isUTC = function () { return !!this.$u; }, e.toISOString = function () { return this.toDate().toISOString(); }, e.toString = function () { return this.toDate().toUTCString(); }; const r = e.toDate; e.toDate = function (t) { return t === 's' && this.$offset ? n(this.format('YYYY-MM-DD HH:mm:ss:SSS')).toDate() : r.call(this); }; const a = e.diff; e.diff = function (t, i, e) { if (t && this.$u === t.$u) return a.call(this, t, i, e); const s = this.local(); var t = n(t).local(); return a.call(s, t, i, e); }; }; }));
!(function (t, e) { typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = e() : typeof define === 'function' && define.amd ? define(e) : (t = typeof globalThis !== 'undefined' ? globalThis : t || self).dayjs_plugin_timezone = e(); }(this, function () { 'use strict'; const s = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }; const m = {}; return function (t, e, a) { function f(t, e, n) { void 0 === n && (n = {}); let i; const o = new Date(t); return i = (void 0 === n ? {} : n).timeZoneName || 'short', (n = m[t = e + '|' + i]) || (n = new Intl.DateTimeFormat('en-US', { hour12: !1, timeZone: e, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: i }), m[t] = n), n.formatToParts(o); } function r(t, e) { for (var n = f(t, e), i = [], o = 0; o < n.length; o += 1) { var r = n[o]; var u = r.type; var r = r.value; var u = s[u]; u >= 0 && (i[u] = parseInt(r, 10)); } return e = i[3], e = i[0] + '-' + i[1] + '-' + i[2] + ' ' + (e === 24 ? 0 : e) + ':' + i[4] + ':' + i[5] + ':000', t = +t, (a.utc(e).valueOf() - (t - t % 1e3)) / 6e4; } let u; var e = e.prototype; e.tz = function (t, e) { void 0 === t && (t = u); const n = this.utcOffset(); const i = this.toDate(); const o = i.toLocaleString('en-US', { timeZone: t }); var r = Math.round((i - new Date(o)) / 1e3 / 60); var r = a(o).$set('millisecond', this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - r, !0); return e && (e = r.utcOffset(), r = r.add(n - e, 'minute')), r.$x.$timezone = t, r; }, e.offsetName = function (t) { const e = this.$x.$timezone || a.tz.guess(); var t = f(this.valueOf(), e, { timeZoneName: t }).find(function (t) { return t.type.toLowerCase() === 'timezonename'; }); return t && t.value; }; const i = e.startOf; e.startOf = function (t, e) { if (!this.$x || !this.$x.$timezone) return i.call(this, t, e); const n = a(this.format('YYYY-MM-DD HH:mm:ss:SSS')); return i.call(n, t, e).tz(this.$x.$timezone, !0); }, a.tz = function (t, e, n) { let i = n && e; var n = n || e || u; var e = r(+a(), n); if (typeof t !== 'string') return a(t).tz(n); i = (function (t, e, n) { let i = t - 60 * e * 1e3; const o = r(i, n); if (e === o) return [i, e]; n = r(i -= 60 * (o - e) * 1e3, n); return o === n ? [i, o] : [t - 60 * Math.min(o, n) * 1e3, Math.max(o, n)]; }(a.utc(t, i).valueOf(), e, n)), e = i[0], i = i[1], i = a(e).utcOffset(i); return i.$x.$timezone = n, i; }, a.tz.guess = function () { return Intl.DateTimeFormat().resolvedOptions().timeZone; }, a.tz.setDefault = function (t) { u = t; }; }; }));

dayjs.extend(window.dayjs_plugin_utc);
dayjs.extend(window.dayjs_plugin_timezone);

dayjs.tz.setDefault('Europe/Berlin');
// eslint-disable-next-line
Vue.component('shipping-countdown', {

  data() {
    return {
      currentInterval: null,
      duration: null,
      remainSeconds: null,
      textEnd: '',
      holidays: []
    };
  },

  created() {
    this.initializeDataAndTimer();
  },

  methods:
  {
    initializeDataAndTimer() {
      const currentYear = new Date().getFullYear();
      $.ajax({
        type: 'GET',
        url: 'https://feiertage-api.de/api/?jahr=' + currentYear + '&nur_daten=1',
        dataType: 'jsonp',
        crossDomain: true,
        success: (data) => {
          this.holidays = Object.values(data);

          clearInterval(this.currentInterval);
          this.calculations();
          this.currentInterval = setInterval(() => {
            this.calculations();
          }, 1000);
        }
      });
    },

    calculateRemainsSeconds() {
      const transDays = [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
      ];
      const momentNow = dayjs().tz('Europe/Berlin');

      let momentTarget = dayjs(momentNow);
      let nextDaySend = false;
      while (momentTarget.get('day') == 0 || momentTarget.get('day') == 6 || this.holidays.includes(momentTarget.format('YYYY-MM-DD'))) {
        nextDaySend = true;
        momentTarget = momentTarget.add(1, 'day');
      }
      const currentDay = momentTarget.get('day');
      let momentEnd = dayjs(momentTarget);

      const momentOne = dayjs(momentTarget).hour(13).minute(59).second(59);
      if (currentDay >= 1 && currentDay < 5) {
        // Mon-Thu
        if (momentNow.valueOf() < momentOne.valueOf()) { // 00-14
          this.remainSeconds = momentOne.diff(momentNow, 'second');
        } else { // 14-24
          momentEnd = dayjs(momentTarget).add(1, 'day').hour(13).minute(59).second(59);
          while (momentEnd.get('day') == 0 || momentEnd.get('day') == 6 || this.holidays.includes(momentEnd.format('YYYY-MM-DD'))) {
            momentEnd = momentEnd.add(1, 'day');
          }
          this.remainSeconds = momentEnd.diff(momentNow, 'second');
          nextDaySend = true;
        }
      } else if (currentDay == 5) {
        // Fri
        if (momentNow.valueOf() < momentOne.valueOf()) { // 00-14
          this.remainSeconds = momentOne.diff(momentNow, 'second');
        } else { // 14-24
          momentEnd = dayjs(momentTarget).add(1, 'weeks').day(1).hour(13).minute(59).second(59);
          while (momentEnd.get('day') == 0 || momentEnd.get('day') == 6 || this.holidays.includes(momentEnd.format('YYYY-MM-DD'))) {
            momentEnd = momentEnd.add(1, 'day');
          }
          this.remainSeconds = momentEnd.diff(momentNow, 'second');
          nextDaySend = true;
        }
      } else {
        // Fri - Sun
        momentEnd = dayjs(momentTarget).add(1, 'weeks').day(1).hour(13).minute(59).second(59);
        while (momentEnd.get('day') == 0 || momentEnd.get('day') == 6 || this.holidays.includes(momentEnd.format('YYYY-MM-DD'))) {
          momentEnd = momentEnd.add(1, 'day');
        }
        this.remainSeconds = momentEnd.diff(momentNow, 'second');
        nextDaySend = true;
      }

      if (nextDaySend) {
        if (momentEnd.diff(momentNow, 'day') == 0 && momentEnd.get('day') != momentNow.get('day')) {
          this.textEnd = 'und wir verschicken Ihre Sendung <span class="hl">bereits morgen, am ' + transDays[momentEnd.get('day')] + ', ' + momentEnd.format('DD.MM.YYYY') + '!</span>';
        } else {
          this.textEnd = 'und wir verschicken Ihre Sendung <span class="hl">bereits am ' + transDays[momentEnd.get('day')] + ', ' + momentEnd.format('DD.MM.YYYY') + '!</span>';
        }
      } else {
        this.textEnd = 'und wir verschicken Ihre Sendung <span class="hl">HEUTE!</span>';
      }
    },

    calculations() {
      this.calculateRemainsSeconds();
      this.duration = this.getDuration(this.remainSeconds);
    },

    getDuration(seconds) {
      const days = Math.floor(seconds / (60 * 60 * 24));
      seconds = seconds - (days * 60 * 60 * 24);
      const hours = Math.floor(seconds / (60 * 60));
      seconds = seconds - (hours * 60 * 60);
      const minutes = Math.floor(seconds / 60);
      seconds = seconds - (minutes * 60);

      return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      };
    }
  },

  template: `
      <div class="shipping-countdown-container" v-if="!!duration">
          <div>
              <div>Bestellen Sie innerhalb von</div>
              <span class="shipping-countdown-group">
                  <span class="shipping-countdown-days" v-if="duration.days > 0"><span class="val" v-text="duration.days"></span> T.</span>
                  <span class="shipping-countdown-hours" v-if="duration.hours > 0"><span class="val" v-text="duration.hours"></span> Std.</span>
                  <span class="shipping-countdown-minutes"><span class="val" v-text="duration.minutes"></span> Min.</span>
                  <span class="shipping-countdown-seconds"><span class="val" v-text="duration.seconds"></span> Sek.</span>
              </span>
              <span v-html="textEnd"></span>
          </div>
      </div>
  `
});

$(function () {
  const singleItemParallax = $('.single-item-parallax');

  $(window).on('scroll', function () {
    const scroll = $(document).scrollTop();

    singleItemParallax.css({
      'background-position': '0% ' + (-0.4 * scroll) + 'px'
    });
  });

  $("body").on("click", ".btn[data-toggle='modal'][href='#registration']", function()
  {
      $('#registration-picker').modal('hide');
      window.ceresStore.dispatch("loadComponent", "register-modal");
  });

  $("body").on("click", ".btn[data-toggle='modal'][href='#registration-b2b']", function()
  {
      $('#registration-picker').modal('hide');
      window.ceresStore.dispatch("loadComponent", "register-b2b-modal");
  });

  $("body").on("click", ".widget-step-by-step-image-navigation .showmore", function()
  {
      const root = $(this).closest(".widget-step-by-step-image-navigation");
      root.toggleClass("expand");
  });

  $('body').on('click', '.widget-link-list.collapsible .widget-inner .h4', function () {
    const list = $(this).parent().find('ul.list-unstyled');
    if (list.is(':visible')) {
      $(this).parent().addClass('collapsed');
    } else {
      $(this).parent().removeClass('collapsed');
    }
    list.slideToggle('fast');
  });

  $('body').on('click', '.sidebar-collapse-block .title', function () {
    $(this).parent().toggleClass('active');
  });

  $('#shippingscosts').on('show.bs.modal', function () {
    const modalBody = $(this).find('.modal-body');
    fetch("https://www.herrmann-hygiene.de/content/versand-und-zahlungsbedingungen/")
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const pageBody = doc.querySelector('#page-body > .container-max > .row > .col');
        if(pageBody && pageBody.innerHTML) {
          modalBody.html(pageBody.innerHTML);
        }
      });
  });

  if (!App.isShopBuilder) {
    if (window.matchMedia('(max-width: 544px)').matches) {
      $('.widget-link-list.collapsible .widget-inner .h4').click();
    }
    $(window).resize(function () {
      if (window.matchMedia('(max-width: 991.98px)').matches) {
        $('#page-header .navbar').removeClass('unfixed');
      } else {
        $('#page-header .navbar').addClass('unfixed');
      }
    });
    $(window).trigger('resize');

    if (window.matchMedia('(max-width: 991.98px)').matches) {
      $(".widget-step-by-step-basic-navigation").each(function () {
        const widget = $(this);
        new ScrollBooster({
          viewport: widget.find(".widget-container")[0],
          content: widget.find(".widget-inner")[0],
          scrollMode: "transform",
          direction: "horizontal",
          emulateScroll: true
        })
      });
    }

    setInterval(() => {
      $(".widget-tab .tab-pane").each(function () {
        if ($(this)[0].textContent.trim().length > 0 || $(this)[0].querySelector("img, iframe, picture")) {
          $(this).removeClass("empty-content");
        } else {
          $(this).addClass("empty-content");
        }
      });
    }, 800);


    var firmaChecker = setInterval(function () {
      if ($('.nav-tabs [href="#firma"]').length) {
        clearInterval(firmaChecker);
        if (window.location.hash == '#firma') {
          const link = $('.nav-tabs [href="#firma"]');
          if (link && link.length) {
            $('.nav-tabs [href="#firma"]')[0].click();
          }
        }

      }
    }, 200);

    setInterval(function () {
      const commentLineHeight = 21;
      const commentPaddingVertical = 20;
      const maxHeight = commentLineHeight * 3 + commentPaddingVertical;

      $(".feedback-container .feedback-list .feedback:not(.show-more-passed) .feedback-comment .feedback-comment-text").each(function () {
        const parentFeedback = $(this).closest(".feedback");
        if ($(this).height() > maxHeight) {
          parentFeedback.addClass("has-more");
          $(this).after("<span class='show-more'>mehr anzeigen...</span>");
        }
        parentFeedback.addClass("show-more-passed");
      });
    }, 400);

    $('body').on('click', '.feedback-container .feedback-list .feedback .show-more', function () {
      const parentFeedback = $(this).closest(".feedback");
      parentFeedback.toggleClass("expanded");
    });
  }


  const genderHashChecker = setInterval(() => {
    const hash = location.hash.replace(/^#/, ''); // ^ means starting, meaning only match the first hash
    if (hash) {
      $('.nav-tabs.gender-tabs a[href="#' + hash + '"]').tab('show');
      clearInterval(genderHashChecker);
    } else {
      clearInterval(genderHashChecker);
    }
  }, 200);

  $('.widget-home-box .show-more').on('click', function (event) {
    $(this).closest('.widget-home-box').toggleClass('active');
    $(this).closest('.widget-home-box').find('.hidden-content-container').slideToggle(300);
  });

  setInterval(() => {
    window.ceresStore.commit('setShippingPrivacyHintAccepted', true);
  }, 500);
});

function runAfterElementExists2(jquery_selector, callback) {
  var checker = setInterval(function () {
    if ($(jquery_selector).length) {
      clearInterval(checker);
      callback();
    }
  }, 200);
}
runAfterElementExists2('.single .crossprice>del', function () {
  var oldUVP = $('.single .crossprice>del').text().replace(/,/, '.').replace(/EUR/, ' ');
  var currentPrice = $('.single .has-crossprice .price>span:first-child').text().replace(/,/, '.').replace(/EUR/, ' ');
  var oldUVP = oldUVP.replace(/[^0-9\.]+/g, '');
  var currentPrice = currentPrice.replace(/[^0-9\.]+/g, '');

  function calculatePercent() {
    const percent = (oldUVP - currentPrice) / oldUVP * 100;
    const percentRound = Math.round(percent);
    $('.article_saving_row .saving_p').html(' (-' + percentRound + '%)');
    $('.article_saving_badge .saving_p').html('-' + percentRound + '%');
    var currentSaving = oldUVP - currentPrice;
    currentSaving = currentSaving.toFixed(2).replace(/\./, ',');
    $('#saving_eur').html(currentSaving + ' EUR');
  };
  calculatePercent();
});